<template>
  <div>
    <el-form :inline="true">
      <el-row>
        <el-col :span="6">
          <el-form-item label="患儿姓名">
            <el-input type="text" v-model="form.searchCond.childName" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="救助编号">
            <el-input type="text" v-model="form.searchCond.helpId" placeholder="请输入" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <SearchButton @search="queryList" @reset="reset" @expand="(e) => (expand = e)">
            <el-button icon="el-icon-plus" type="primary" size="small" @click="newBtnFunction">新增</el-button>
          </SearchButton>
        </el-col>
      </el-row>
      <el-row v-if="expand">
        <el-col :span="6">
          <el-form-item label="申请时间">
            <DateRangePicker v-model="registerTime"></DateRangePicker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="身份证号">
            <el-input type="text" v-model="form.searchCond.idNumber" placeholder="请输入" size="small" />
          </el-form-item>
        </el-col>
        <el-col v-if="active == 'todo'" :span="6">
          <el-form-item label="救助状态">
            <DictionarySelect v-model="form.searchCond.apprStatus" :lazy="true" tableCode="APPROVE_STATUS" :excludeKeys="['5']"></DictionarySelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="审核时间">
            <DateRangePicker v-model="apprTime"></DateRangePicker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import HospitalSelect from "@/components/business/HospitalSelect";
  import DiseaseCascader from "@/components/business/DiseaseCascader";
  import SearchButton from "@/components/business/SearchButton";
  import DictionarySelect from "@/components/business/DictionarySelect";
  import LocationCascader from "@/components/business/LocationCascader";
  import DateRangePicker from "@/components/business/DateRangePicker";
  import {
    getCMDictByTableCodeApi
  } from '../../../util/api.js'
  export default {
    components: {
      HospitalSelect,
      DiseaseCascader,
      SearchButton,
      DictionarySelect,
      LocationCascader,
      DateRangePicker,
    },
    props: {
      active: String
    },
    data() {
      let isHospitalRole = this.isHospital();
      return {
        isHospitalRole: isHospitalRole,
        expand: false,
        location: [],
        registerTime: [],
        diseasesIdList: [],
        form: {
          pageNO: 1,
          pageSize: 10,
          searchCond: {}
        },
      };
    },
    methods: {
      reset() {
        this.location = [];
        this.registerTime = [];
        this.apprTime = [];
        this.form.searchCond = {};
        this.queryList();
      },
      queryList() {
        this.form.pageNO = 1;
        if (this.registerTime && this.registerTime.length > 1) {
          this.form.searchCond.registerTimeBegin = this.registerTime[0];
          this.form.searchCond.registerTimeEnd = this.registerTime[1];
        } else {
          this.form.searchCond.registerTimeBegin = null;
          this.form.searchCond.registerTimeEnd = null;
        }
        if (this.apprTime && this.apprTime.length > 1) {
          this.form.searchCond.apprTimeBegin = this.apprTime[0];
          this.form.searchCond.apprTimeEnd = this.apprTime[1];
        } else {
          this.form.searchCond.apprTimeBegin = null;
          this.form.searchCond.apprTimeEnd = null;
        }
        if (this.location.length > 2) {
          this.form.searchCond.province = this.location[0];
          this.form.searchCond.city = this.location[1];
          this.form.searchCond.county = this.location[2];
        } else {
          this.form.searchCond.province = null;
          this.form.searchCond.city = null;
          this.form.searchCond.county = null;
        }
        this.$emit("query", this.form);
      },
      newBtnFunction() {
        this.$emit("newBtnFun");
        this.$emit("newChecked")
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "src/common/tableScreenCss";
  @import "src/common/form";
</style>



// WEBPACK FOOTER //
// src/pages/child/hospital/HospitalChidSearch.vue